import BaseEndpoint from "../common/BaseEndpoint";

const apiPath = '/api/v1/a/order';

class OrderEndPoint extends BaseEndpoint {
  deliveryAddressUpdate(data) {
    return this.client.$post(`${apiPath}/update`, data);
  }

  getRussianPostTrackNumber(params) {
    return this.client.$get(`${apiPath}/get-track-number`, {params});
  }
}

export default OrderEndPoint;